import { render } from "./AddNotificationModal.vue?vue&type=template&id=a8ec1dbc&scoped=true"
import script from "./AddNotificationModal.vue?vue&type=script&lang=js"
export * from "./AddNotificationModal.vue?vue&type=script&lang=js"

import "./AddNotificationModal.vue?vue&type=style&index=0&id=a8ec1dbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ec1dbc"]])

export default __exports__